import React, { Component } from "react";
import { scrollIntoView } from "../../lib/util";

interface Props {
  offset?: string;
}

export default class ScrollIntoView extends Component<Props> {
  ref = React.createRef<HTMLDivElement>();

  componentDidMount() {
    const el = this.ref.current;
    if (el) scrollIntoView(el);
  }

  render() {
    const { offset = "-150px" } = this.props;
    return (
      <>
        <div style={{ transform: `translateY(${offset})` }} ref={this.ref} />
        {this.props.children}
      </>
    );
  }
}
